/**
 * get last build versions from 'body data-t' html tag
 * @param {Array} htmlPage html page from which extract body tag
 * @return {String} last build versions
 */

const getLastBuildVersions = (htmlPage) => {
    try {
        return new DOMParser().parseFromString(htmlPage, 'text/html').body.getAttribute('data-v');
    } catch (error) {
        throw new Error(`Couldn't get last build versions due to error: ${error}`);
    }
};
export default getLastBuildVersions;